/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react'
import { useQueryClient } from 'react-query'
import { Navigate } from 'react-router-dom'
import { notification } from 'antd'

import { AuthApi, removeAuthHeader } from '@api'
import { useGeneral, useUser } from '@contexts'

import LoadingSpinner from '../../components/LoadingSpinner'

const Logout = () => {
  const { state, setState } = useUser()
  const qClient = useQueryClient()
  const { setTicketToSearch, ticketToSearch } = useGeneral()
  const [step, setStep] = useState<number>()

  useEffect(() => {
    if (state?.id) AuthApi.removeFirebaseToken(state.id)
    setStep(1)
  }, [])

  useEffect(() => {
    if (step === 1) {
      window.localStorage.clear()
      removeAuthHeader()
      qClient.clear()
      notification.destroy()
      setTicketToSearch(undefined)
      setState(undefined)
      setStep(2)
    }
  }, [step])

  useEffect(() => {
    if (step === 2 && !ticketToSearch && !state) {
      setStep(3)
    }
  }, [ticketToSearch, step, state])

  return step === 3 ? <Navigate to="/login" /> : <LoadingSpinner />
}

export { Logout }
